"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithDot = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DotWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  ", "\n  right: 0;\n"])), function (_ref) {
  var position = _ref.position;
  return "".concat(position, ": 0;");
});
var WithDot = function WithDot(_ref2) {
  var children = _ref2.children,
    position = _ref2.position,
    dot = _ref2.dot;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-inline-block position-relative"
  }, children, /*#__PURE__*/_react.default.createElement(DotWrapper, {
    position: position
  }, dot));
};
exports.WithDot = WithDot;